export function generateCustomId() {
  // 1. Get the timestamp (as string, 13 digits for ms)
  const timestamp = Date.now().toString(); // e.g. "1722926124940"
  // 2. Split in half
  const mid = Math.floor(timestamp.length / 2);
  const firstHalf = timestamp.slice(0, mid);
  const secondHalf = timestamp.slice(mid);
  // 3. Generate a uuid (remove dashes)
  let uuid = "";
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    uuid = crypto.randomUUID().replace(/-/g, "");
  } else {
    // fallback for older environments (simple polyfill for demo)
    uuid = "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx".replace(/[x]/g, function () {
      return ((Math.random() * 16) | 0).toString(16);
    });
  }
  // 4. Concatenate as per your pattern
  return firstHalf + uuid + secondHalf;
}
